import React, {useCallback} from "react";
import {useDispatch} from "react-redux";
import {reviewActions} from "../review.slice";
import styled from "styled-components";
import { ThemeProps } from "../../styles/theme";

const Root = styled.div<ThemeProps>`
    padding: 30px;
    background-color: ${props => props.theme.secondaryBackground};
    box-sizing: border-box;
`;

const ActionButton = styled.button<ThemeProps>`
    display: block;
    margin: 0 auto;
    font-size: 1em;
    background-color: ${props => props.theme.neutralButtonBackground};
    color: ${props => props.theme.neutralButtonForeground};
    outline: none;
    border: ${props => props.theme.neutralButtonBorder} 1px solid;
    padding: 8px 16px;

    &:focus {
        background-color: ${props => props.theme.neutralButtonBorder};
    }
`;

export const ShowAnswerButton: React.FC = () => {
    const dispatch = useDispatch();
    const showAnswer = useCallback(
        () => dispatch(reviewActions.showAnswer()),
        [dispatch]
    );

    return (
        <Root>
            <ActionButton data-testid="review-show-answer" onClick={showAnswer}>Show Answer</ActionButton>
        </Root>
    );
}